module.exports = __webpack_public_path__ + "static/img/envelope01.6f4a42f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope01.png
// module id = 2IDq
// module chunks = 1